;(function () {
  angular.module('contrast.cve').directive('csCveInfo', [csCveInfo])

  function csCveInfo() {
    var validVulnTypes = {
      app: true,
      lib: true
    }
    return {
      restrict: 'A',
      controller: 'csCveInfoCtrl',
      controllerAs: 'csCveInfoCtrl',
      bindToController: {
        csCveInfo: '='
      },
      link: function (scope, elem, attrs, ctrl) {
        elem.on('click', function (e) {
          if (!angular.isObject(ctrl.csCveInfo)) {
            throw new Error(
              'csCveInfo requires an object with data and type properties'
            )
          }
          if (
            !angular.isString(ctrl.csCveInfo.type) ||
            !validVulnTypes[ctrl.csCveInfo.type]
          ) {
            throw new Error(
              'Only the following are valid vuln-type values: ' +
                Object.keys(validVulnTypes).join(',')
            )
          }
          ctrl.activate()
          e.preventDefault()
        })
      }
    }
  }
}).call(this)
